var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgControldLogoSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 32,
    viewBox: "0 0 44 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.59866 15C0.732718 15 0.0400039 14.2664 0.181462 13.4121C1.44086 5.80615 8.11505 0 16.3343 0H19.7144C20.4244 0 21.0001 0.575634 21.0001 1.28571C21.0001 8.85991 14.86 15 7.28578 15H1.59866Z",
    fill: "#E8EFFF",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.59859 17C0.732651 17 0.0399357 17.7336 0.181394 18.5879C1.44081 26.1938 8.11505 32 16.3343 32H19.7144C20.4244 32 21.0001 31.4244 21.0001 30.7143C21.0001 23.1401 14.86 17 7.28578 17H1.59859Z",
    fill: "#E8EFFF",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7143 17C29.1401 17 23 23.1401 23 30.7143C23 31.4244 23.5756 32 24.2857 32H27.6657C35.885 32 42.5592 26.1938 43.8186 18.5879C43.9601 17.7336 43.2673 17 42.4014 17H36.7143Z",
    fill: "#E8EFFF",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4014 15C43.2674 15 43.9601 14.2664 43.8186 13.4121C42.5592 5.80615 35.885 0 27.6657 0H24.2857C23.5756 0 23 0.575634 23 1.28571C23 8.85991 29.1401 15 36.7143 15H42.4014Z",
    fill: "#E8EFFF",
    fillOpacity: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControldLogoSmall);
export default __webpack_public_path__ + "static/media/controld-logo-small.a3735b6ee3def94dd34e9f231fa4b61d.svg";
export { ForwardRef as ReactComponent };